import { BaseAPIModel } from '@weezevent/weezjs-core';

export class UserV1 extends BaseAPIModel {
    fields() {
        return {
            username: { primaryKey: true, readOnly: true },
            name: {}
        };
    }

    getEmail() {
        return this.email || '';
    }

    get resolvedName() {
        const firstName = this.object.first_name || '';
        const lastName = (this.object.last_name || '').toUpperCase();
        const app = this.object.application_name;
        return app ? app : (firstName && lastName ? `${firstName} ${lastName}` : firstName || lastName) || '-';
    }

    get clientId() {
        const name = this.object.username;
        if (!name.includes('app_')) {
            return null;
        }
        return name.replace('app_', '');
    }

    static listUrl({ organizationId, useCase }) {
        const endpoint = useCase === 'applications' ? 'v1/applications' : 'users';

        if (!organizationId) {
            return `/ticket/${endpoint}`;
        }
        return `/ticket/organizations/${organizationId}/${endpoint}`;
    }

    static getItemUrl({ id, useCase, ...props }) {
        if (useCase === 'applications' && id.startsWith('user_')) {
            id = id.slice(5, id.length);
        }
        return super.getItemUrl({ id, useCase, ...props });
    }
}
